// extracted by css-extract-rspack-plugin
export default {"Box":"get-sub-issues-block-module__Box__Q6qp9","Box_1":"get-sub-issues-block-module__Box_1__eS4fc"};